var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"atlas-chat-loader-anchor",attrs:{"aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }